import {
  Context,
  useReviewFactory,
  UseReviewFactoryParams
} from '@vue-storefront/core';
import type { Review } from '@bee-hole/api';
import type {
  UseReviewSearchParams as SearchParams,
  UseReviewAddParams as AddParams
} from '../types';
import { useApiError } from '../useApiError';

const params1: UseReviewFactoryParams<Review, SearchParams, AddParams> = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  searchReviews: async (context: Context, params) => {
    // console.log('查询评论：',params);
    const res = await context.$xbuy.api.customOrderReview(params);
    // console.error("res",res);
    // if (res.code > 0) {
    //   context.useApiError.set(res);
    //   throw new Error(res.message);
    // }
    return res?.data?.list || [];
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addReview: async (context: Context, params) => {
    // console.log('添加评论：', params);
    const res = await context.$xbuy.api.customAddReview(params);
    // console.log('添加评论返回结果：', res);
    if (res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    } else {
      context.useApiError.set(res);
      return await params1.searchReviews(context, { goods_id: params.goods_id, sku_id: params.sku_id, order_id: params.order_id });
    }
  }
};

export const useReview = useReviewFactory<Review, SearchParams, AddParams>(params1);
